import React from 'react';

const PrivacyPage: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
      CafeLawn respects your privacy. This page will be updated with our full privacy policy. For
      questions, contact{' '}
      <a href="mailto:support@cafelawn.com" className="text-purple-600 hover:underline">
        support@cafelawn.com
      </a>
      .
    </p>
  </div>
);

export default PrivacyPage;
